import GluceraNavigationRoutes from "./navigationRoutes";
import OnboardingWelcome from "../pages/OnboardingWelcome";
import OnbordingLoginpage from "../pages/OnbordingLoginpage";
import Genderpage from "../pages/Genderpage";
import Racepage from "../pages/Racepage";
import Agepage from "../pages/Agepage";
import HeightWeightPage from "../pages/Heightweightpage";
import Typeofdiabetes from "../pages/Typeofdiabetes";
import Addmedications from "../pages/Addmedications";
import weightloss from "../pages/weightloss";
import TargetWeight from "../pages/TargetWeight";
import HomePage from "../pages/HomePage";
import MealCameraPage from "../pages/MealCameraPage";
import ScannedFooddetailPage from "../pages/ScannedFooddetailPage";
import ScannedFoodDetail from "../pages/ScannedFoodDetail";
import EditFoodPage from "../pages/EditFoodPage";
import AddFoodPage from "../pages/AddFoodPage";
import FoodNutritionPage from "../pages/FoodNutritionPage";
import CurrentMedications from "../pages/currentmedications";
import mainresonweightloss from "../pages/MainReasonWeightLoss";
import workoutpage from "../pages/workoutpage";
import Dietpage from "../pages/Dietpage";
import Eatmealpage from "../pages/Eatmealpage";
import IntermittentFastingPage from "../pages/intermitingfastingpage";
import eatingwindowpage from "../pages/eatingwindowpage";
import AssessmentSummary from "../pages/AssessmentSummary";
import thankyoupage from "../pages/thankyoupage";
import appdevicespage from "../pages/appdevicespage";
import fitbitConnectionPage from "../pages/fitbitConnectionPage";
import FitbitCallbackPage from "../pages/FitbitCallbackPage";
import profilepage from "../pages/profilepage";
import ActivityPage from "../pages/ActivityPage";
import Mealpage from "../pages/Mealpage";
import mealdetailpage from "../pages/mealdetailpage";
import mealindetailpage from "../pages/mealindetailpage";
import Addmealpage from "../pages/Addmealpage";
import addmedicationpage from "../pages/addmedicationpage";
import connnettofitbitpage from "../pages/connnettofitbitpage";
import FitnessPage from "../pages/FitnessPage";
import TrendsPage from "../pages/TrendsPage";
import EditProfilePage from "../pages/EditProfilePage";
import GlucoseReadingsPage from "../pages/GlucoseReadingsPage";
import GoalsPage from "../pages/GoalsPage";
import ConnectedDevicesPage from "../pages/ConnectedDevicesPage";
import NotificationsPage from "../pages/NotificationsPage";
import PreferencesPage from "../pages/PreferencesPage";
import PrivacySecurityPage from "../pages/PrivacySecurityPage";
import HelpSupportPage from "../pages/HelpSupportPage";
import AboutPage from "../pages/AboutPage";
import GettingStartedPage from "../pages/GettingStartedPage";
import FAQsPage from "../pages/FAQsPage";
import ContactSupportPage from "../pages/ContactSupportPage";
import TermsOfServicePage from "../pages/TermsOfServicePage";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage";
import LicensesPage from "../pages/LicensesPage";
import StepsDetail from "../pages/ActivityPage/StepsDetail";
import HeartRateDetail from "../pages/ActivityPage/HeartRateDetail";
import CaloriesBurnedDetail from "../pages/ActivityPage/CaloriesBurnedDetail";
import ActiveMinutesDetail from "../pages/ActivityPage/ActiveMinutesDetail";
import HealthVitalsAll from "../pages/ActivityPage/HealthVitalsAll";
import SleepDetail from "../pages/ActivityPage/SleepDetail";
import SpO2Detail from "../pages/ActivityPage/SpO2Detail";
import BreathingDetail from "../pages/ActivityPage/BreathingDetail";
import TemperatureDetail from "../pages/ActivityPage/TemperatureDetail";
import StressScoreDetail from "../pages/ActivityPage/StressScoreDetail";
import HRVDetail from "../pages/ActivityPage/HRVDetail";
import NutritionSummary from "../pages/NutritionSummary";
import MealHistory from "../pages/MealHistory";
import BiteBalance from "../pages/BiteBalance";
import BBSDetailPage from "../pages/BBSDetailPage";
import FourPillarsDetailPage from "../pages/FourPillarsDetailPage";
import BarcodeProductDetail from "../pages/BarcodeProductDetail";
import PRALScoreDetail from "../pages/PRALScoreDetail";
import MicronutrientRiskDetail from "../pages/MicronutrientRiskDetail";
import GutRestDetail from "../pages/GutRestDetail";
import RecoveryHRVDetail from "../pages/RecoveryHRVDetail";
import CarbFiberRatioDetail from "../pages/CarbFiberRatioDetail";
import FatQualityDetail from "../pages/FatQualityDetail";
import MicroDiversityDetail from "../pages/MicroDiversityDetail";
import FoodScoreDetail from "../pages/FoodScoreDetail";
import SugarLoadDetail from "../pages/SugarLoadDetail";
import MetabolicStabilityDetail from "../pages/MetabolicStabilityDetail";
import LifestyleScoreDetail from "../pages/LifestyleScoreDetail";
import MedicationManagement from "../pages/MedicationManagement";
import SuggestedWorkouts from "../pages/SuggestedWorkouts";
import ExerciseVideos from "../pages/ExerciseVideos";
import DailyInsightsPage from "../pages/DailyInsightsPage";
import GroupMemberDetailPage from "../pages/GroupMemberDetailPage";
import GroupMembersListPage from "../pages/GroupMembersListPage";
import InviteMemberPage from "../pages/InviteMemberPage";
import WeightManagementDetail from "../pages/WeightManagementDetail";
import HealthInsightsPage from "../pages/HealthInsightsPage";
import CustomScreenPage from "../pages/CustomScreenPage";

const protectedRoutes = [
  {
    path: GluceraNavigationRoutes.HOME,
    element: HomePage,
    name: "Home",
  },
  {
    path: GluceraNavigationRoutes.HOMEPAGE,
    element: HomePage,
    name: "HomePage",
  },
  {
    path: GluceraNavigationRoutes.FITNESS,
    element: FitnessPage,
    name: "Fitness",
  },
  {
    path: GluceraNavigationRoutes.TRENDS_PAGE,
    element: TrendsPage,
    name: "Trends",
  },
  {
    path: GluceraNavigationRoutes.STEPS_DETAIL,
    element: StepsDetail,
    name: "Steps Detail",
  },
  {
    path: GluceraNavigationRoutes.HEART_RATE_DETAIL,
    element: HeartRateDetail,
    name: "Heart Rate Detail",
  },
  {
    path: GluceraNavigationRoutes.CALORIES_DETAIL,
    element: CaloriesBurnedDetail,
    name: "Calories Burned Detail",
  },
  {
    path: GluceraNavigationRoutes.ACTIVE_MINUTES_DETAIL,
    element: ActiveMinutesDetail,
    name: "Active Minutes Detail",
  },
  {
    path: GluceraNavigationRoutes.HEALTH_VITALS_ALL,
    element: HealthVitalsAll,
    name: "Health Vitals All",
  },
  {
    path: GluceraNavigationRoutes.SLEEP_DETAIL,
    element: SleepDetail,
    name: "Sleep Detail",
  },
  {
    path: GluceraNavigationRoutes.SPO2_DETAIL,
    element: SpO2Detail,
    name: "SpO2 Detail",
  },
  {
    path: GluceraNavigationRoutes.BREATHING_DETAIL,
    element: BreathingDetail,
    name: "Breathing Detail",
  },
  {
    path: GluceraNavigationRoutes.TEMPERATURE_DETAIL,
    element: TemperatureDetail,
    name: "Temperature Detail",
  },
  {
    path: GluceraNavigationRoutes.STRESS_SCORE_DETAIL,
    element: StressScoreDetail,
    name: "Stress Score Detail",
  },
  {
    path: GluceraNavigationRoutes.HRV_DETAIL,
    element: HRVDetail,
    name: "HRV Detail",
  },
  {
    path: GluceraNavigationRoutes.NUTRITION_SUMMARY,
    element: NutritionSummary,
    name: "Nutrition Summary",
  },
  {
    path: GluceraNavigationRoutes.MEAL_HISTORY,
    element: MealHistory,
    name: "Meal History",
  },
  {
    path: GluceraNavigationRoutes.BITE_BALANCE,
    element: BiteBalance,
    name: "Gut Health Score",
  },
  {
    path: GluceraNavigationRoutes.BBS_DETAIL,
    element: BBSDetailPage,
    name: "Bite Balance Score",
  },
  {
    path: GluceraNavigationRoutes.FOUR_PILLARS_DETAIL,
    element: FourPillarsDetailPage,
    name: "Your 4 Pillars",
  },
  {
    path: GluceraNavigationRoutes.BARCODE_PRODUCT_DETAIL,
    element: BarcodeProductDetail,
    name: "Product Details",
  },
  {
    path: GluceraNavigationRoutes.PRAL_SCORE,
    element: PRALScoreDetail,
    name: "PRAL Score Detail",
  },
  {
    path: GluceraNavigationRoutes.MICRONUTRIENT_RISK,
    element: MicronutrientRiskDetail,
    name: "Micronutrient Risk Detail",
  },
  {
    path: GluceraNavigationRoutes.GUT_REST,
    element: GutRestDetail,
    name: "Gut Rest Detail",
  },
  {
    path: GluceraNavigationRoutes.RECOVERY_HRV,
    element: RecoveryHRVDetail,
    name: "Recovery HRV Detail",
  },
  {
    path: GluceraNavigationRoutes.CARB_FIBER,
    element: CarbFiberRatioDetail,
    name: "Carb Fiber Ratio Detail",
  },
  {
    path: GluceraNavigationRoutes.FAT_QUALITY,
    element: FatQualityDetail,
    name: "Fat Quality Detail",
  },
  {
    path: GluceraNavigationRoutes.MICRO_DIVERSITY,
    element: MicroDiversityDetail,
    name: "Micro Diversity Detail",
  },
  {
    path: GluceraNavigationRoutes.FOOD_SCORE,
    element: FoodScoreDetail,
    name: "Food Score Detail",
  },
  {
    path: GluceraNavigationRoutes.SUGAR_LOAD,
    element: SugarLoadDetail,
    name: "Sugar Load Detail",
  },
  {
    path: GluceraNavigationRoutes.METABOLIC_STABILITY,
    element: MetabolicStabilityDetail,
    name: "Metabolic Stability Detail",
  },
  {
    path: GluceraNavigationRoutes.LIFESTYLE_SCORE,
    element: LifestyleScoreDetail,
    name: "Lifestyle Score Detail",
  },
  {
    path: GluceraNavigationRoutes.MEDICATIONS,
    element: MedicationManagement,
    name: "Medication Management",
  },
  {
    path: GluceraNavigationRoutes.SUGGESTED_WORKOUTS,
    element: SuggestedWorkouts,
    name: "Suggested Workouts",
  },
  {
    path: GluceraNavigationRoutes.EXERCISE_VIDEOS,
    element: ExerciseVideos,
    name: "Exercise Videos",
  },
  {
    path: GluceraNavigationRoutes.AI_INSIGHTS,
    element: DailyInsightsPage,
    name: "Daily AI Insights",
  },
  {
    path: GluceraNavigationRoutes.EDIT_PROFILE,
    element: EditProfilePage,
    name: "Edit Profile",
  },
  {
    path: GluceraNavigationRoutes.GLUCOSE_READINGS,
    element: GlucoseReadingsPage,
    name: "Glucose Readings",
  },
  {
    path: GluceraNavigationRoutes.PROFILE_GOALS,
    element: GoalsPage,
    name: "Goals",
  },
  {
    path: GluceraNavigationRoutes.PROFILE_DEVICES,
    element: ConnectedDevicesPage,
    name: "Connected Devices",
  },
  {
    path: GluceraNavigationRoutes.NOTIFICATIONS,
    element: NotificationsPage,
    name: "Notifications",
  },
  {
    path: GluceraNavigationRoutes.PROFILE_PREFERENCES,
    element: PreferencesPage,
    name: "Preferences",
  },
  {
    path: GluceraNavigationRoutes.PROFILE_PRIVACY,
    element: PrivacySecurityPage,
    name: "Privacy & Security",
  },
  {
    path: GluceraNavigationRoutes.PROFILE_HELP,
    element: HelpSupportPage,
    name: "Help & Support",
  },
  {
    path: GluceraNavigationRoutes.PROFILE_ABOUT,
    element: AboutPage,
    name: "About Bite Balance",
  },
  {
    path: GluceraNavigationRoutes.GETTING_STARTED,
    element: GettingStartedPage,
    name: "Getting Started",
  },
  {
    path: GluceraNavigationRoutes.FAQS,
    element: FAQsPage,
    name: "FAQs",
  },
  {
    path: GluceraNavigationRoutes.CONTACT_SUPPORT,
    element: ContactSupportPage,
    name: "Contact Support",
  },
  {
    path: GluceraNavigationRoutes.TERMS_OF_SERVICE,
    element: TermsOfServicePage,
    name: "Terms of Service",
  },
  {
    path: GluceraNavigationRoutes.LICENSES,
    element: LicensesPage,
    name: "Licenses",
  },
  {
    path: GluceraNavigationRoutes.GENDER_PAGE,
    element: Genderpage,
    name: "Gender Page",
  },
  {
    path: GluceraNavigationRoutes.RACE_PAGE,
    element: Racepage,
    name: "Race Page",
  },
  {
    path: GluceraNavigationRoutes.AGE_PAGE,
    element: Agepage,
    name: "Age Page",
  },
  {
    path: GluceraNavigationRoutes.HEIGHT_WEIGHT_PAGE,
    element: HeightWeightPage,
    name: "Height Weight Page",
  },
  {
    path: GluceraNavigationRoutes.TYPE_OF_DIABETES,
    element: Typeofdiabetes,
    name: "Type of Diabetes",
  },
  {
    path: GluceraNavigationRoutes.CURRENT_MEDICATIONS,
    element: CurrentMedications,
    name: "Current Medications",
  },
  {
    path: GluceraNavigationRoutes.ADD_MEDICATIONS,
    element: Addmedications,
    name: "Add Medications",
  },
  {
    path: GluceraNavigationRoutes.WEIGHT_LOSS,
    element: weightloss,
    name: "Weight Loss",
  },
  {
    path: GluceraNavigationRoutes.TARGET_WEIGHT,
    element: TargetWeight,
    name: "Target Weight",
  },
  {
    path: GluceraNavigationRoutes.MAIN_REASON_WEIGHT_LOSS,
    element: mainresonweightloss,
    name: "Main Reason Weight Loss",
  },
  {
    path: GluceraNavigationRoutes.WORKOUT_PAGE,
    element: workoutpage,
    name: "Workout Page",
  },
  {
    path: GluceraNavigationRoutes.EATMEALPAGE,
    element: Eatmealpage,
    name: "Eatmeal Page",
  },
  {
    path: GluceraNavigationRoutes.DIETPAGE,
    element: Dietpage,
    name: "Diet Page",
  },
  {
    path: GluceraNavigationRoutes.MEAL_CAMERA,
    element: MealCameraPage,
    name: "Meal Camera Page",
  },
  {
    path: GluceraNavigationRoutes.SCANNED_FOOD_DETAIL,
    element: ScannedFooddetailPage,
    name: "Scanned Food Detail Page",
  },
  {
    path: GluceraNavigationRoutes.SCANNED_BARCODE_DETAIL,
    element: ScannedFoodDetail,
    name: "Scanned Barcode Detail Page",
  },
  {
    path: GluceraNavigationRoutes.EDIT_FOOD,
    element: EditFoodPage,
    name: "Edit Food Page",
  },
  {
    path: GluceraNavigationRoutes.ADD_FOOD,
    element: AddFoodPage,
    name: "Add Food Page",
  },
  {
    path: GluceraNavigationRoutes.FOOD_NUTRITION,
    element: FoodNutritionPage,
    name: "Food Nutrition Page",
  },
  {
    path: GluceraNavigationRoutes.IntermittentFastingPage,
    element: IntermittentFastingPage,
    name: "Intermittent Fasting Page",
  },
  {
    path: GluceraNavigationRoutes.eatingwindowpage,
    element: eatingwindowpage,
    name: "eatingwindowpage",
  },
  {
    path: GluceraNavigationRoutes.appdevicespage,
    element: appdevicespage,
    name: "appdevicespage",
  },
  {
    path: GluceraNavigationRoutes.ASSESSMENT_SUMMARY,
    element: AssessmentSummary,
    name: "AssessmentSummary",
  },
  {
    path: GluceraNavigationRoutes.thankyoupage,
    element: thankyoupage,
    name: "thankyoupage",
  },
  {
    path: GluceraNavigationRoutes.fitbitConnectionPage,
    element: fitbitConnectionPage,
    name: "fitbitConnectionPage",
  },
  {
    path: GluceraNavigationRoutes.fitbitCallbackPage,
    element: FitbitCallbackPage,
    name: "FitbitCallbackPage",
  },
  {
    path: GluceraNavigationRoutes.profilepage,
    element: profilepage,
    name: "profilepage",
  },
  {
    path: GluceraNavigationRoutes.ActivityPage,
    element: ActivityPage,
    name: "ActivityPage",
  },
  {
    path: GluceraNavigationRoutes.Mealpage,
    element: Mealpage,
    name: "Mealpage",
  },
  {
    path: GluceraNavigationRoutes.mealdetailpage,
    element: mealdetailpage,
    name: "mealdetailpage",
  },
  {
    path: GluceraNavigationRoutes.mealindetailpage,
    element: mealindetailpage,
    name: "mealindetailpage",
  },
  {
    path: GluceraNavigationRoutes.ADDMEALPAGE,
    element: Addmealpage,
    name: "Add Meal Page",
  },
  {
    path: GluceraNavigationRoutes.ADDMEDICATIONPAGE,
    element: addmedicationpage,
    name: "Add Medications",
  },
  {
    path: GluceraNavigationRoutes.connnettofitbitpage,
    element: connnettofitbitpage,
    name: "connect to fitbit page",
  },
  {
    path: GluceraNavigationRoutes.GROUP_MEMBER_DETAIL,
    element: GroupMemberDetailPage,
    name: "Group Member Detail",
  },
  {
    path: GluceraNavigationRoutes.GROUP_MEMBERS_LIST,
    element: GroupMembersListPage,
    name: "Group Members List",
  },
  {
    path: GluceraNavigationRoutes.INVITE_MEMBER,
    element: InviteMemberPage,
    name: "Invite Member",
  },
  {
    path: GluceraNavigationRoutes.WEIGHT_MANAGEMENT_DETAIL,
    element: WeightManagementDetail,
    name: "Weight Management Detail",
  },
  {
    path: GluceraNavigationRoutes.HEALTH_INSIGHTS,
    element: HealthInsightsPage,
    name: "Health Insights",
  },
  {
    path: GluceraNavigationRoutes.CUSTOM_SCREEN,
    element: CustomScreenPage,
    name: "Measure",
  },
];

const publicRoutes: { path: string; element: any; name: string }[] = [
  {
    path: GluceraNavigationRoutes.ONBOARDING_WELCOME,
    element: OnboardingWelcome,
    name: "Onboarding Welcome",
  },
  {
    path: GluceraNavigationRoutes.ONBOARDING_LOGINPAGE,
    element: OnbordingLoginpage,
    name: "Onboarding Login",
  },
  {
    path: GluceraNavigationRoutes.PRIVACY_POLICY,
    element: PrivacyPolicyPage,
    name: "Privacy Policy",
  },
];

const routes = [
  {
    type: "auth",
    routes: protectedRoutes,
  },
  {
    type: "public",
    routes: publicRoutes,
  },
];

export default routes;
